module.exports = __webpack_public_path__ + "static/media/BhawalRajbari.62629e81.jpg";